// extracted by mini-css-extract-plugin
module.exports = {"block":"RadioGroup_block__185e_","root":"RadioGroup_root__ye9gs","groupLabel":"RadioGroup_groupLabel__3DJ1s","required":"RadioGroup_required__WF1z-"};